import React, { useEffect, useRef } from "react";
import ApexCharts from "apexcharts";
import PropTypes from "prop-types";

const MedicineChart = ({ getMedicineSalesData }) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    if (!chartRef.current) return;

    const dates =
      getMedicineSalesData?.medicine_sales?.map(
        (item) => item.sale_date
      ) || [];

    const sales =
      getMedicineSalesData?.medicine_sales?.map((item) =>
        Math.abs(item.total_sales)
      ) || [];

    const options = {
      chart: {
        height: 230,
        type: "area",
        toolbar: { show: false },
      },
      stroke: {
        curve: "smooth",
      },
      dataLabels: {
        enabled: false,
      },
      series: [
        {
          name: "Sales",
          data: sales.length ? sales : [0],
        },
      ],
      xaxis: {
        categories: dates.length ? dates : [""],
      },
      yaxis: {
        labels: {
          formatter: (value) => value.toFixed(0),
        },
      },
    };

    // 🔥 Destroy old chart before creating new one
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }

    chartInstance.current = new ApexCharts(chartRef.current, options);
    chartInstance.current.render();

    // 🧹 Cleanup on unmount
    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
        chartInstance.current = null;
      }
    };
  }, [getMedicineSalesData]);

  return <div ref={chartRef} />;
};

MedicineChart.propTypes = {
  getMedicineSalesData: PropTypes.object,
};

export default MedicineChart;
